/**
 * This is a seperate file to help with code splitting
 */

export const DEFAULT_GRAPH_WIDTH = 400;
